import { lazy, Suspense, useEffect, useState } from "react";

const FloatingCTALazy = lazy(() =>
  import("./floating-cta").then((m) => ({ default: m.FloatingCTA })),
);

/**
 * Ne monte le floating CTA qu'après une interaction réelle
 * de l'utilisateur (scroll, pointer, key, touch).
 * Objectif : zéro coût JS sur le LCP / TBT initial (PageSpeed).
 */
export function DeferredChrome() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    let done = false;
    const trigger = () => {
      if (done) return;
      done = true;
      setReady(true);
    };

    const evs = ["scroll", "pointerdown", "keydown", "touchstart"] as const;
    evs.forEach((e) =>
      window.addEventListener(e, trigger, { once: true, passive: true }),
    );

    return () => {
      evs.forEach((e) => window.removeEventListener(e, trigger));
    };
  }, [ready]);

  return (
    <>
      <Suspense fallback={null}>
        {ready && <FloatingCTALazy />}
      </Suspense>
      <Suspense fallback={null}>
        <BarParfumPromoLazy />
      </Suspense>
    </>
  );
}

const BarParfumPromoLazy = lazy(() =>
  import("./bar-parfum-promo").then((m) => ({ default: m.BarParfumPromo })),
);
